export default __webpack_public_path__ + "static/media/macdonald.69fd4c16.png";